const state = {
    columnSort: {},
}

export default state